import { upsertIdeas } from 'common/actions/ideas';
import queryActionFactory from 'common/actions/queryActionFactory';
import DataV2 from 'common/DataV2';

import type { Idea } from 'common/api/endpoints/idea';
import type { View } from 'common/api/endpoints/view';
import type { FiltersOperator } from 'common/fieldFilters/utils';
import type { Filter } from 'common/views/filters';
import type { Dispatch } from 'redux';

export type QueryParams = {
  groupURLName?: string;
  parentID?: string;
  search?: string;
  sort?: View['sort'];
  viewURLName?: string;
  filtering?: {
    filters: Filter[];
    filtersOperator: FiltersOperator;
  };
};

export const {
  // query helpers
  getQueryKey,

  // action creators
  invalidateQueries: invalidateIdeaQueries,
  loadQuery,
  loadMore,
  reloadQuery: reloadIdeaQuery,
  removeItem,

  // action types
  BulkLoadedType,
  RequestType,
  RequestMoreType,
  LoadedType,
  LoadedMoreType,
  ErrorType,
  InvalidateType,
  RemoveType,
} = queryActionFactory<Idea, QueryParams>('ideaQueries', DataV2.queries.ideas, {
  // when new ideas are loaded, add the full idea objects to the `ideas` store
  onItemsLoaded: async (dispatch: Dispatch, items: Idea[]) => {
    await dispatch(upsertIdeas(items));
  },
});
